//@ts-nocheck
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import React, { useContext } from "react";
import Typography from '../../commonComponents/Typography/Typography';
import EyeBrow from "../../commonComponents/eyeBrow/eyeBrow";
import HlxButton from "../../commonComponents/button/button";
import DefaultPC from "../../../assets/images/placeholder-pc.png";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { ThemeContext } from 'styled-components';
import { NOT_APPLICABLE } from '../../../constants/originalState';
import { DeviceStyle, IconHeaderStyle } from "./device.style";
import { StyledIcon } from '../../commonComponents/Icon/icon.style';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import {GridSize} from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HealthyChip from 'component/commonComponents/HealthyChip';
import { ComputerKeyboardIcon } from "component/commonComponents/Icon";
import { DEVICE_STATUS } from '../../../constants/originalState';
import { PerformanceConfig } from "models/Device";

export interface IDeviceProps {
  deviceData?: any,
  locale?: any,
  handleMoreActions:()=> void,
  index?: any,
  isShowAction?: boolean,
  horizontal?: boolean,
  isShowType?: boolean,
  horizontalColSpanImg?: GridSize,
  isShowPrimaryLabel?: boolean,
  isHideEyeBrow?: boolean,
  isShowKeyboard?: boolean,
  performanceConfig?: PerformanceConfig;
  performance?: string;
  localePerformance?: any;
};

const Device = (props: IDeviceProps) => {
  const theme = useContext(ThemeContext);
  const { deviceData, locale, handleMoreActions, index, isShowAction, horizontal, isShowType, horizontalColSpanImg, isShowPrimaryLabel, isHideEyeBrow, performanceConfig, performance, isShowKeyboard, localePerformance } = props;
  if (!deviceData.model_picture)
    deviceData.model_picture = DefaultPC;

  const assetEyebrow = deviceData?.process_stage?.asset_eyebrow?.toUpperCase() || '';

  const asset_Status = deviceData.asset_function?.toUpperCase();
  const textAssetFunction = locale?.commonStatus?.[asset_Status]?` - ${locale?.commonStatus[asset_Status]}`:'';

  const isOrange = [DEVICE_STATUS.INACTIVE].includes(!!assetEyebrow && assetEyebrow);

  const iconEyeBrow= deviceData?.process_stage?.stage?.toUpperCase() === DEVICE_STATUS.ELIGIBLE_FOR_REFRESH ? (
    <StyledIcon
      styleIcon={{
        fontSize: theme.uptimeFontSizes.desktop.fz5,
        color: isOrange ? theme.uptimeColors.deviceCardEyebrow.deviceCard.color : theme.uptimeColors.mainTheme.primary,
        width: theme.uptimeSpace[8],
        height:theme.uptimeSpace[8]
      }}
    >
      <RefreshOutlinedIcon />
    </StyledIcon>
  ): '';

  let eyeBrowText ='';
  if(isShowPrimaryLabel){
    if(deviceData?.process_stage?.stage === DEVICE_STATUS.ELIGIBLE_FOR_REFRESH){
      eyeBrowText=`${locale?.readyForRefresh}${textAssetFunction}`;
    }
    else{
      eyeBrowText=`${!!assetEyebrow ? locale?.commonStatus[assetEyebrow] : locale?.commonStatus['IN USE']}${textAssetFunction}`;
    }
  }else{
    if(deviceData?.process_stage?.stage === DEVICE_STATUS.ELIGIBLE_FOR_REFRESH){
      eyeBrowText=`${locale?.readyForRefresh} - ${!!assetEyebrow ? locale?.commonStatus[assetEyebrow] : locale?.commonStatus['IN USE']}`;
    }
    else{
      eyeBrowText=`${!!assetEyebrow ? locale?.commonStatus[assetEyebrow] : locale?.commonStatus['IN USE']}`;
    }
  }

  const colorEyeBrow = isOrange ? theme.uptimeColors.deviceCardEyebrow.deviceCard.color : theme.uptimeColors.mainTheme.primary ;
  const backgroundEyeBrow = isOrange ? theme.uptimeColors.deviceCardEyebrow.deviceCard.background : theme.uptimeColors.mainTheme.light ;

  const getSelectedKeyboard = () => {
    if (deviceData.keyboard) {
      return deviceData.keyboard;
    }
    return (
      deviceData.keyboards?.find(
        (i) => i.code === deviceData.keyboardSelected
      ) || {}
    );
  };

  return (

    <DeviceStyle index={index}>
        <Grid item xs={12}>
          <Card
            className="card card-wrap"
          >
            <Grid container direction={horizontal ? 'row' : 'column'}>
              <Grid item {...(horizontal ? (isShowAction ? { xs: 5, sm: 3, md: 2 } : { xs: !!horizontalColSpanImg ? horizontalColSpanImg : 4 }) : {})} className="img-thumbnail">
                <div className="cardMedia">
                  <Grid
                    container
                    direction="row"
                    alignContent="center"
                    className="h-100"
                  >
                    <img src={deviceData.model_picture} alt={deviceData.model} title={deviceData.model} />
                  </Grid>
                </div>
              </Grid>

              <Grid item {...(horizontal ? (isShowAction ? { xs: 7, sm: 6, md: 8 } : { xs: (!!horizontalColSpanImg ? (12 - horizontalColSpanImg) : 8) }) : {})}>
                <div className="cardDetails">
                  {!isHideEyeBrow && <Grid container direction="row" alignItems="center">
                    <EyeBrow
                      position='initial'
                      color={colorEyeBrow}
                      backgroundColor={backgroundEyeBrow}
                      text={eyeBrowText}
                      marginBottom={theme.uptimeSpace[4]}
                      icon={iconEyeBrow}
                    />
                  </Grid>}
                  <div className={horizontal ? "cardContent" : ""}>
                    <Typography className="captionRegular">
                      {deviceData.manufacturer}
                    </Typography>
                    <Typography className="heading5">
                      {deviceData.model}
                    </Typography>
                    <div className="device-card-configuration">
                      <IconHeaderStyle>
                        <LocalOfferIcon />
                      </IconHeaderStyle>
                      <div className="device-card-configuration-header">
                        {locale?.serialNumber}
                      </div>
                      <div className="device-card-configuration-content" title={deviceData.serial_number}>
                        {!!deviceData.serial_number ? deviceData.serial_number : NOT_APPLICABLE}
                      </div>
                    </div>

                    {isShowKeyboard && (
                      <div className="device-card-configuration keyboard-type">
                        <div>
                          <ComputerKeyboardIcon className="spec-icon MuiSvgIcon-root" />
                        </div>
                        <div className="device-card-configuration-header">
                          {locale?.keyboard}
                        </div>
                        <div className="device-card-configuration-content">
                          {getSelectedKeyboard()?.name || NOT_APPLICABLE}
                        </div>
                      </div>
                    )}

                    {isShowType && <div className="device-card-configuration device-type">
                    <IconHeaderStyle>
                      <GpsFixedIcon />
                    </IconHeaderStyle>
                    <div className="device-card-configuration-header">
                      {locale?.deviceType}
                    </div>
                    <div className="device-card-configuration-content" title={deviceData?.type}>
                      {!!deviceData?.type ? deviceData.type : NOT_APPLICABLE}
                    </div>
                  </div>}

                    {performanceConfig?.isEnabledTachyon && performance && (
                      <div className="device-card-configuration">
                        <IconHeaderStyle>
                          <CheckCircleOutlineIcon />
                        </IconHeaderStyle>
                        <div className="device-card-configuration-header">
                          {locale?.deviceHealth}
                        </div>
                        <HealthyChip
                          performanceConfig={performanceConfig}
                          performance={performance}
                          localeText={localePerformance}
                        />
                      </div>
                    )}                  
                  </div>
                </div>
              </Grid>
              {isShowAction && (
                <Grid item xs={12} sm={3} md={2}>
                  <div className="cardButton">
                    <HlxButton label={locale?.moreAction} onClick={handleMoreActions} id="btn-device-more" />
                  </div>
                </Grid>
              )}
            </Grid>
          </Card>
        </Grid>
    </DeviceStyle>
  );
};

Device.defaultProps = {
  deviceData: {
    asset_function: null,
    asset_tag: "AG972332",
    assigned_date: "2021-03-25 10:42:50",
    company: "DXC Technology",
    configuration: {
      cpu: "N/A",
      vga_card: "N/A",
      disk: "N/A",
      osLicence: "N/A",
      since: "N/A",
    },
    deviceStatus: "Ready for Refresh",
    device_profile: "",
    device_type: "laptop",
    display_name: "<p>AG972332 - Lenovo ThinkPad T430</p>",
    eligible_for_refresh: "false",
    image: "/static/media/emptyLaptop01-removebg-preview.8e5daae6.png",
    isRefresh: true,
    last_active: "N/A",
    manufacturer: "Lenovo",
    model: "Lenovo ThinkPad T430",
    model_category: "Computer",
    model_description: null,
    model_number: "2349A66",
    model_picture:
      "https://uptime4340f158ad8483d0.blob.core.windows.net/device-image/793d774a1b8674d0f2949682b24bcb44",
    os: "Windows 7 Enterprise",
    process_stage: {
      asset_eyebrow: "In Use",
      stage: "ELIGIBLE_FOR_REFRESH",
      stage_text: "ACTION REQUIRED",
      task_eyebrow: "Action Required",
    },
    processing: 100,
    serial_number: "PG84994",
    spec_cpu_core_count: "",
    spec_cpu_count: "",
    spec_cpu_manufacturer: "",
    spec_cpu_name: "Intel(R) Core(TM) i5-3320M CPU @ 2.60GHz@2.594GHz",
    spec_cpu_speed: "2,594",
    spec_cpu_type: "Intel(R) Core(TM) i5-3320M CPU @ 2.60GHz",
    spec_disk_space: "",
    spec_os_service_pack: "",
    spec_os_version: "",
    spec_ram: "3,884,652",
    state: "In use",
    substate: null,
    uid: "21182818db35bb00568acebe3b9619d4",
    tachyon: {
      enabled: true,
      data: {
        Fqdn: 'ci_name',
        TachyonGuid: 'uid',
        Timestamp: '2023-03-28T00:00:00Z',
        ExperienceScore: 66,
        StabilityScore: 97,
        PerformanceScore: 69,
        ResponsivenessScore: 33,
        SentimentScore: null,
        OsCrashesScore: 100,
        OsServiceFailuresScore: 70,
        SoftwareCrashesScore: 90,
        SoftwareHangsScore: 100,
        HealthStatus: {
          GradingValue: 'GOOD',
          GradingText: 'Good',
          HintText:
            'Your overall device experience score is good, this means that your device is meeting the expected performance level based on metrics for performance, stability and responsiveness.',
          KbNumber: 'KB0018578',
        },
      },
    },
  },
  locale: {
    serialNumber: 'Serial number',
    moreAction: 'More Actions',
    readyForRefresh:'Ready for Refresh',
    na: 'N/A',
    deviceType: 'Device Type',
    commonStatus: {},
    deviceHealth: "Device Health",
  },
  isShowAction: true,
  horizontal: true,
  isShowType: false,
  horizontalColSpanImg: 0,
  isHideEyeBrow: false,
};

export default Device;
